import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/items/item_waivers";
import useWaiverStore from "../../../stores/useWaiverStore";
import WushPopover from "../../layout/WushPopover";
import create from "../../../api/auth/items/item_waivers/create";
import WushCard from "../../layout/WushCard";
import { Delete } from "@mui/icons-material";
import destroy from "../../../api/auth/items/item_waivers/destroy";

export default function ItemWaiversForm({ item }) {
  const [ itemWaivers, setItemWaivers ] = useState([]);

  const { waivers } = useWaiverStore();

  useEffect(() => {
    index(item.id, (response) => {
      setItemWaivers(response);
    });
  }, []);

  const handleCreateItemWaiver = (waiverId) => {
    create(item.id, { waiver_id: waiverId }, (response) => {
      setItemWaivers([...itemWaivers, response]);
    });
  };

  const handleDelete = (itemWaiver) => {
    destroy(item.id, itemWaiver.id, () => {
      setItemWaivers(itemWaivers.filter((iw) => iw.id !== itemWaiver.id));
    });
  };

  return (
    <Stack>
      <Stack>
        <Typography variant="h5">
          Waivers
        </Typography>
        <Typography variant="body2">
          Attached waivers will be included in the confirmation email to the customer
        </Typography>
      </Stack>
      <Stack mb={1}>
        <WushPopover
          anchor={
            <Stack>
              <Button>
                + Attach Waiver
              </Button>
            </Stack>
          }
        >
          <Stack>
            {waivers.map((waiver) => (
              <Button onClick={() => handleCreateItemWaiver(waiver.id)} key={waiver.id}>
                <Stack>
                  {waiver.name}
                </Stack>
              </Button>
            ))}
          </Stack>
        </WushPopover>
      </Stack>
      <Stack>
        {itemWaivers.map((itemWaiver) => (
          <WushCard key={itemWaiver.id}>
            <Stack direction="row" p={1} spacing={2}>
              <IconButton size="small" onClick={() => handleDelete(itemWaiver)}>
                <Delete />
              </IconButton>
              <Typography sx={{ my: 'auto !important' }}>
                {itemWaiver.waiver_name} - {itemWaiver.waiver_description}
              </Typography>
            </Stack>
          </WushCard>
        ))}
      </Stack>
    </Stack>
  );
}